import { Heading } from '@nbirl/nbi-common-ui-libs';

import { UploadsCount, UploadsView } from './components';

export const Uploads = () => (
  <>
    <Heading className="py-6 mb-1">
      <UploadsCount />
    </Heading>

    <UploadsView />
  </>
);
